<div class="st-tile-column-list-header">
    <div class="st-tile-column-header-dayName">{{ column?.displayName }}</div>
    <div class="st-tile-column-header-day">{{ column?.day }}</div>
    <button
        *ngIf="column.displayName"
        mat-icon-button
        class="st-tile-column-header-addItem"
        [matTooltip]="languageSettings.PSTWebAddNewTopicText"
        (click)="createTopic.next()">
        <mat-icon>add</mat-icon>
    </button>
    <div
        *ngIf="column?.displayName && costVisible"
        class="st-tile-column-header-cost">
        {{ totalCost() | currency: 'USD' }}
    </div>
</div>
<cdk-virtual-scroll-viewport
    class="st-tile-column-timeline-column-data"
    [itemSize]="itemSize$ | ngrxPush">
    <div
        *cdkVirtualFor="let record of records$ | ngrxPush; let i = index; trackBy: trackByGuid; templateCacheSize: 0"
        class="st-tile-column-timeline-day-cell-holder"
        cdkDrag
        [cdkDragData]="getDragData(record, column)">
        <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: { record: record, index: i, column: column } }" />
    </div>
</cdk-virtual-scroll-viewport>
